<style lang="scss" scoped>
@media screen and (max-width: 575px) {
  #responsive-navigation {
    background-color: rgba(26, 26, 26, 0.9);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
.first,
.previous,
.next,
.last {
  position: relative;
}
.previous,
.last {
  margin-left: -15px;
}
.previous,
.next {
  z-index: 2;
}
.first,
.last {
  opacity: 0.5;
}
</style>

<template>
  <div
    v-if="view && (view['hydra:next'] || view['hydra:previous'])"
    :id="responsive ? 'responsive-navigation' : ''"
    class="p-3 mb-sm-3 text-center"
  >
    <button
      :class="'btn btn-circle btn-secondary first' + (!view['hydra:previous'] ? ' invisible' : '')"
      @click="getPage(view['hydra:first'])"
      :title="$t('global.first')"
    >
      <font-awesome-icon icon="angle-double-left" size="lg"/>
    </button>
    <button
      :class="'btn btn-circle btn-secondary previous' + (!view['hydra:previous'] ? ' invisible' : '')"
      @click="getPage(view['hydra:previous'])"
      :title="$t('global.previous')"
    >
      <font-awesome-icon icon="angle-left" size="lg"/>
    </button>
    <button
      :class="'btn btn-circle btn-secondary next' + (!view['hydra:next'] ? ' invisible' : '')"
      @click="getPage(view['hydra:next'])"
      :title="$t('global.next')"
    >
      <font-awesome-icon icon="angle-right" size="lg"/>
    </button>
    <button
      :class="'btn btn-circle btn-secondary last' + (!view['hydra:next'] ? ' invisible' : '')"
      @click="getPage(view['hydra:last'])"
      :title="$t('global.last')"
    >
      <font-awesome-icon icon="angle-double-right" size="lg"/>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    view: {},
    getPage: {},
    responsive: {
      default: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/app/Pagination.vue